module.exports = __webpack_public_path__ + "img/project1.ae010e26.jpg";